import React from 'react';
import { inject, observer } from 'mobx-react';
import MeetingModal from '@/models/meeting';
import UserModel from '@/models/user';
import 'swiper/swiper.less';
import GridLayout from '../GridLayout';

interface ViewPanelProps {
  meeting?: MeetingModal;
  user?: UserModel;
}

const ViewPanel: React.FC<ViewPanelProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    user: store.user,
  };
})(
  observer((props: ViewPanelProps) => {
    const { meeting } = props;
    return <GridLayout list={meeting?.sortMembers}></GridLayout>;
  })
);
export default ViewPanel;
